import { render, staticRenderFns } from "./Tipologie.vue?vue&type=template&id=54c34d18&"
import script from "./Tipologie.vue?vue&type=script&lang=js&"
export * from "./Tipologie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports